import type { TourSection } from './types';

export const ingestEventsSections: TourSection[] = [
  {
    id: 'filters',
    label: 'Filtros de eventos',
    steps: [
      {
        target: '[data-tour="ingest-events-filters"]',
        title: 'Filtros del listado',
        content:
          'Busca eventos por estado (pendiente/procesando/éxito/fallado), operación (crear/actualizar/eliminar), cliente que emitió, SKU o rango de fechas. Los filtros se guardan en la URL para compartir.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado de eventos',
    steps: [
      {
        target: '[data-tour="ingest-events-table"]',
        title: 'Tabla de eventos',
        content:
          'Cada fila es un intento de ingesta que llegó al pipeline. Click en la fila para ver el detalle y el payload que llegó. Las filas con fondo rojo son fallos que quedaron sin procesar.',
      },
    ],
  },
];
